// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2dNM2","subheader":"ReorderModal_subheader__f6szS","listWrap":"ReorderModal_listWrap__3udf8"};